/**
 * Table tennis match format catalog (Casual Arena defaults).
 * ITTF: rally to 11 win by 2; matches typically best of 5 or 7 (casual also allows best of 3).
 */

import { SPORT_IDS } from "../../../domain/sport/sportTypes";

/** @type {import("../../../domain/sport/sportMatchFormatCatalog").SportMatchFormatCatalog} */
export const TABLE_TENNIS_MATCH_FORMAT = Object.freeze({
  sportId: SPORT_IDS.TABLE_TENNIS,
  displayName: "Table Tennis",
  matchTypes: [
    { id: "singles", title: "Singles", sub: "1v1", matchType: "singles", playersPerSide: 1 },
    { id: "doubles", title: "Doubles", sub: "2v2", matchType: "doubles", playersPerSide: 2 },
  ],
  setsOptions: [
    { setsToWin: 1, title: "1 Set" },
    { setsToWin: 2, title: "Best of 3" },
    { setsToWin: 3, title: "Best of 5" },
    { setsToWin: 4, title: "Best of 7" },
  ],
  pointsPresets: [
    { mode: 11, title: "First to 11" },
    { mode: 21, title: "First to 21 (legacy)" },
    { mode: "custom", title: "Custom" },
  ],
  defaultSetsToWin: 3,
  defaultPointsToWin: 11,
  customPoints: {
    min: 1,
    max: 21,
    label: "Custom points",
    placeholder: "11",
  },
  customSets: {
    min: 1,
    max: 7,
    label: "Custom best of",
    oddOnly: true,
  },
  pointsChipLabel: "Points",
  courtPresentationId: "table_tennis.court.v1",
  intervalPresentationId: "table_tennis.interval.v1",
  scoringSystem: "rally",
});
